import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetMastersSalaryList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMastersSalaryListForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/GetListForMaster");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMasterSumSalary extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/GetSum");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMasterSalaryDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/Detailes");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterSalaryDetailsForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/DetailesForMaster");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterDetailsForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/GetByIdForMaster");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMainReportList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterUserPayment/GetMainReportList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetMastersSalaryList,
  GetMasterSumSalary,
  GetMasterSalaryDetails,
  GetMasterDetails,
  GetMainReportList,
  GetMastersSalaryListForMaster,
  GetMasterDetailsForMaster,
  GetMasterSalaryDetailsForMaster,
};
